import React from 'react'
import { useHotmartEvent } from '../../hooks/useHotmartEvent'

const Video = ({ link = '', eventdh = '' }) => {
  const { sendHotmartEvent } = useHotmartEvent()

  const sendDHEvent = () => {
    if (!eventdh) {
      return void 0
    }

    const evtData = { title: eventdh, url: link }

    sendHotmartEvent({
      entity: 'tracking',
      action: 'play',
      event: evtData,
    })
  }

  return (
    <video width="80%" data-testid="video-player" onPlay={sendDHEvent} controls>
      <source src={link} type="video/mp4" />
    </video>
  )
}

export default Video
